import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, inject, effect, ViewChild, } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@services/core/user.service';
import { BudgetGenerateService } from '@services/budget-generate.service';
import { Entity } from '@model/entity.model';
import Swal from 'sweetalert2'
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { LOCALE_ID } from '@angular/core';
import { FilterModel } from './filter.model';
import { saveAs } from 'file-saver';
import { Workbook } from 'exceljs';
import { BudgetOverViewComponent } from '../budget-over-view/budget-over-view.component';
import jsPDF from 'jspdf'
import { DomSanitizer } from '@angular/platform-browser';
import autoTable from 'jspdf-autotable';



@Component({
  selector: 'app-summary-departament',
  standalone: true,
  imports: [DecimalPipe, NgSelectModule, FormsModule, NgbModule, CommonModule,BudgetOverViewComponent],
  providers: [NgbModal, { provide: LOCALE_ID, useValue: 'es-ES' }],
  templateUrl: './summary-departament.component.html',
  styleUrl: './summary-departament.component.css'
})
export class SummaryDepartamentComponent {
  @ViewChild('preview', { static: true }) preview: any;
  private modalRef: NgbModalRef;
  private _identityService = inject(UserService);
  public ngSelectedOld: string;
  public inputOld;
  public entitySelected: Entity;
  public codeEntity;
  public txtFindAccount;
  public budgetGenerateService= inject(BudgetGenerateService)
  public departament = [];
  public items ;
  public itemsTemp;
  public departamentTemp;
  public fieldName=[];
  public dataListAccounts;
  public subtotal;
  public filter: FilterModel = new FilterModel();
  public navTab = 'dependientes'
  public rows =Array.from({length: 15}, (_, i) => i + 1);
  public cols =Array.from({length: 4}, (_, i) => i + 1);
  public isLoading = true;
  public activeSettingAccount=false;
  public activeSettingDepartament=false;
  public title='Ingresos'
  public budgetFund;
  public fundSelect;
  public budgetVersionSelected;
  public groupedDepartments;
  public revenue;
  public expenses;
  public expenseTotalsByDept;
  public expensesTotalsByDept;
  public groupedByParentThenItem;
  collapseStates: { [key: string]: boolean } = {};
  public factorRea;
  public pdfSrc
  public user;
  collapseStatesIASD: { [key: string]: boolean } = {};
  groupedExpensesDepartamentFund;
  customDidParseCell =  (data) => {
      if (['head', 'foot'].includes(data.section)) {
        if (data.column.index === 0) data.cell.styles.halign = 'left';
        if (data.column.index > 0) data.cell.styles.halign = 'right';
      }
      
    }

    customDidDrawPage = (data) => {
      const { doc } = data;
      const startX = data.table.startX;
      const tableWidth = data.table.width;
  
      // 🔹 Línea bajo el header (pero solo en la primera página de la tabla)
      if (data.pageNumber === 1) {
        const headerBottomY = data.table.head[0].height + data.table.startY;
        doc.line(startX, headerBottomY, startX + tableWidth, headerBottomY);
      }
  
      // 🔹 Línea al final del body (en la última página de la tabla)
      if (data.pageNumber === doc.internal.getNumberOfPages()) {
        const finalY = data.table.finalY;
        doc.line(startX, finalY, startX + tableWidth, finalY);
      }
    }

  
  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  


  constructor(private modalService: NgbModal,private sanitizer: DomSanitizer

  ) {


      effect(()=> {
        this.entitySelected = this._identityService.sharingEntity();
       const budgetFund=this._identityService.sharingBudgetFund()
        this.budgetVersionSelected=this._identityService.sharingBudgetVersion()	
        const user=this._identityService.userData();		
         if (this.budgetVersionSelected?.year) {
          this.user=user;
          this.budgetFund=budgetFund;
          this.fundSelect = this.budgetFund[0]?.fundCode;   
          this.filter.year = this.budgetVersionSelected.year;
          this.filter.version = this.budgetVersionSelected.version; 
          this.getResumenDepartament();
          this.getResumen();
          this.getFactorRea();
        }
      })


  }


  ngOnInit() {


  }

  get isAllCollapsed(): boolean {
    return this.groupedByParentThenItem?.every(group =>
      this.isCollapsed(group)
    );
  }


  isCollapsedIASD(group): boolean {
    const code = group.itemCode;
  
    if (!(code in this.collapseStatesIASD)) {
      // Por defecto colapsar si hay más de 10 elementos (igual que en el otro)
      this.collapseStatesIASD[code] = group.departments?.length > 10;
    }
  
    return this.collapseStatesIASD[code];
  }
  
  toggleCollapseIASD(code: string) {
    this.collapseStatesIASD[code] = !this.collapseStatesIASD[code];
  }
  
  get isAllCollapsedIASD(): boolean {
    return this.groupedDepartments?.every(group =>
      this.isCollapsedIASD(group)
    );
  }
  
  toggleAllCollapseIASD() {
    const newState = !this.isAllCollapsedIASD;
  
    for (const group of this.groupedDepartments) {
      const code = group.itemCode;
      this.collapseStatesIASD[code] = newState;
    }
  }


  
  get columnStyles(): { [key: number]: { cellWidth: number; halign?: string } } {
    if (this.entitySelected?.group === 'IASD') {
      return {
        0: { cellWidth: 180 },
        1: { cellWidth: 105, halign: 'right' },
        2: { cellWidth: 105, halign: 'right' },
        3: { cellWidth: 110, halign: 'right' }
      };
    }
  
    return {
      0: { cellWidth: 160 },
      1: { cellWidth: 58, halign: 'right' },
      2: { cellWidth: 58, halign: 'right' },
      3: { cellWidth: 58, halign: 'right' },
      4: { cellWidth: 58, halign: 'right' },
      5: { cellWidth: 58, halign: 'right' },
      6: { cellWidth: 72, halign: 'right' },
    };
  }
  
 /*abre los modales */
 open(content) {
  this.modalRef = this.modalService.open(content,{ size: 'lg' });
}

 /*cierra los modales */
close() {
  if (this.modalRef) {
    this.modalRef.close();
  }
}

  notification(title) {
    const Toast = Swal.mixin({
      icon: 'success',
      title: title,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
    });
    Toast.fire();
  }

  changeFund(fundCode) {
    this.fundSelect=fundCode;
    if(this.departamentTemp){    
    this.departament = this.departamentTemp.filter(d => 
      d.fundCode==this.fundSelect
    );
    this.groupByItemCode(this.departament);
    this.groupByParentThenItem(this.departament);
    this.changeFundResumen();
    this.groupedExpensesDepartamentFundCode(this.items?.expensesDepartamentFunds);
  }
}

getTotalRevenue(revenueTotals: { fundCode: number; totalValue: number }[]): number {
  return revenueTotals?.reduce((acc, curr) => acc + (curr.totalValue || 0), 0) || 0;
}


groupedExpensesDepartamentFundCode(data) {
  const map = new Map()
  if (Array.isArray(data)) {
  for (const item of data) {
    const key = item?.code;
    if (!map.has(key)) {
      map.set(key, []);
    }
    map.get(key)?.push(item);
  }

   this.totalAndPercentDepartamentFund(Array.from(map.entries()));
}
}

totalAndPercentDepartamentFund(maped){
  this.groupedExpensesDepartamentFund = maped.map(([code, departamentFund]) => {
    const total = departamentFund.reduce((sum, curr) => sum + (curr.totalValue ?? 0), 0);
    const percent = total > 0 ? (total * 100) / this.getTotalRevenue(this.items?.revenueTotals) : 0;
    return {
      code,
      displayName:this.findFactorRea(code)?.displayName,
      departamentFund,
      totalValue:total,
      percent,
    };
  })
}


getValueExpenseDepartamentFund(itemCode,departamentFundCode) {
   const item=this.groupedExpensesDepartamentFund?.find((d) => d.code ==  itemCode);
   const departamentFund=item?.departamentFund?.find((d) => d.departamentFundCode ==  departamentFundCode); 
  return departamentFund?.totalValue ?? 0;
}







findFactorRea(itemCode) {
  return this.factorRea?.find((f) => f.itemCode == itemCode);
}



changeFundResumen() {
  if(this.itemsTemp){
    Object.keys(this.itemsTemp).forEach(key => {
      const arr = this.itemsTemp[key];
      
      if (Array.isArray(arr) && arr.length > 0 && 'fundCode' in arr[0]) {
        this.items[key] = arr.filter(item => item.fundCode == this.fundSelect);
      }
    });
  }
 this.items={...this.items}
}

getFactorRea() {
  let filter = { ...this.filter };
  delete filter.departamentItemCode;
  this.budgetGenerateService.getFactorRea(filter).subscribe((res) => {
    this.factorRea = res;
  });
}


  /**trae los datos de los departamentos de la cuenta seleccionada */
  getResumenDepartament() {
    this.budgetGenerateService.getResumenDepartament(this.filter).subscribe(res => {
      this.subtotal = res.subtotal;
      this.revenue = this.filterRevenue(res);
      this.departament = this.filterDepartament(res).sort((a,b)=>a.itemCode-b.itemCode);
      this.departamentTemp=JSON.parse(JSON.stringify(this.departament));
      this.setFieldName(res);     
      this.changeFund(this.fundSelect);
      Swal.close()
    })
  }




  filterDepartament(data){
    if(this.entitySelected?.group=='IASD'){
      return data.filter(f=>f.itemCode!=3);
    }
    return data;
  }


  filterRevenue(data){
    return data.filter(f=>f.itemCode==3);
  }

  setFieldName(data){
    if(this.entitySelected?.group=='IASD'){
      this.fieldName=data.filter(f=>f.itemCode==3).sort((a,b)=>a.departamentCode-b.departamentCode);
    }
    
  }

  getDepartamentValueIASD(departament: any, fundCode: string): number {
    return departament.fundValues?.[fundCode] || 0;
  }

  /**para  */
  getDepartamentValue(departamentCode: string,itemCode: string): number {
   return  this.departament.find(d => d.departamentCode === departamentCode&&d.itemCode==itemCode);
  }
  

   groupByParentThenItem(data) {
    const parentMap = new Map();
  
    for (const row of data) {
      const parentKey = row.departamentParentCode;
  
      if (!parentMap.has(parentKey)) {
        parentMap.set(parentKey, {
          departamentParentCode: row.departamentParentCode,
          departamentParentName: row.departamentParentName,

          items: []
        });
      }
  
      const parent = parentMap.get(parentKey);
  
      let itemGroup = parent.items.find(i => i.itemCode === row.itemCode);
      if (!itemGroup) {
        itemGroup = {
          itemCode: row.itemCode,
          itemName: row.itemName,
          itemDisplayName: row.itemDisplayName,
          departments: [],
          total: 0
        };
        parent.items.push(itemGroup);
      }
  
      itemGroup.departments.push({
        departamentCode: row.departamentCode,
        departamentDisplayName: row.departamentDisplayName,
        itemCode: row.itemCode,
        fundValues: row.fundValues,
        total: row.total
      });
  
      itemGroup.total += Number(row.total);
    }
   this.orderByParentThenItem(Array.from(parentMap.values()));
  }


addConsolidatedBySubvencion() {
  const subvencionSuffixes = this.getSubvencionSuffixes();
  const itemsMap = this.buildItemsMap(subvencionSuffixes);
  const consolidatedDepartments = [];

  const consolidatedGroup = this.createConsolidatedGroup(itemsMap);
  this.addDepartamentConsolidated(consolidatedGroup, consolidatedDepartments);
}

// --- Métodos auxiliares ---

private getSubvencionSuffixes(): string[] {
  return ["10", "11", "12", "13", "14", "15"];
}

private buildItemsMap(subvencionSuffixes){
  const itemsMap = new Map<number, any>();

  for (const parent of this.groupedByParentThenItem) {
    for (const item of parent.items) {
      for (const dep of item.departments) {
        this.processDepartment(dep, item, subvencionSuffixes, itemsMap);
      }
    }
  }

  return itemsMap;
}

private processDepartment(dep, item, subvencionSuffixes, itemsMap) {
  const code = dep.departamentCode?.toString() ?? "";
  const suffix = code.slice(-2);

  if (!subvencionSuffixes.includes(suffix)) return;

  if (!itemsMap.has(item.itemCode)) {
    itemsMap.set(item.itemCode, {
      itemCode: item.itemCode,
      itemName: item.itemName,
      itemDisplayName: item.itemDisplayName,
      departments: [],
      total: 0
    });
  }

  const itemGroup = itemsMap.get(item.itemCode);
  let depGroup = itemGroup.departments.find((d: any) => d.departamentCode === suffix);

  if (!depGroup) {
    depGroup = {
      departamentCode: suffix,
      departamentDisplayName: this.getDisplayNameBySuffix(suffix),
      itemCode: item.itemCode,
      fundValues: { "-1": 0 },
      total: 0
    };
    itemGroup.departments.push(depGroup);
  }

  const total = Number(dep.total) ?? 0;
  depGroup.total += total;
  depGroup.fundValues["-1"] += total;
  itemGroup.total += total;
}

private createConsolidatedGroup(itemsMap: Map<number, any>) {
  return {
    departamentParentCode: "1",
    departamentParentName: "CONSOLIDADO POR SUBVENCIÓN",
    items: Array.from(itemsMap.values())
  };
}



addDepartamentConsolidated(consolidatedGroup,consolidatedDepartments) {
  for (const item of consolidatedGroup.items) {
    for (const dep of item.departments) {
      consolidatedDepartments.push({
        id: null, 
        itemCode: item.itemCode,
        itemDisplayName: item.itemDisplayName,
        itemName: item.itemName,
        fundCode: -1,
        departamentCode: dep.departamentCode,
        departamentDisplayName: dep.departamentDisplayName,
        departamentParentCode: "1",
        departamentParentName: "CONSOLIDADO POR SUBVENCIÓN",
        fundValues: dep.fundValues,
        total: dep.total
      });
    }
  }
  this.groupedByParentThenItem.push(consolidatedGroup);
  this.departament.push(...consolidatedDepartments);
  
}


getDisplayNameBySuffix(suffix: string) {
  const displayNames: Record<string, string> = {
    "10": "Leyes Especiales",
    "11": "General",
    "12": "SEP",
    "13": "PIE",
    "14": "Pro Retención",
    "15": "Mantenimiento"
  };

  return displayNames[suffix] ?? suffix; 
}



  orderByParentThenItem(data){
   const result =data.map(parent => {
      parent.items.sort((a, b) => a.itemCode - b.itemCode);
      this.orderByDept(parent);
      return parent;
    });

    this.groupedByParentThenItem=result;
    if(this.entitySelected?.group=='FUNDACION'){
      this.addConsolidatedBySubvencion();
    }
    
  }
  
  orderByDept(parent){
    for (const item of parent.items) {
      item.departments.sort((a, b) => a.departamentCode.localeCompare(b.departamentCode));
    }    
    return parent;
  }
    
  getTotalByDepartment(parentGroup, departamentCode) {
    let total = 0;
  
    for (const item of parentGroup.items) {
      const dep = this.findDepartamentValue(item, departamentCode);
      const value = dep ? dep.total : 0;
      const sign = item.itemName === 'expense' ? -1 : 1;
      total += sign * value;
    }
  
    return total;
  }

  findDepartamentValue(parentGroup, departamentCode) {
    const dep = parentGroup.departments.find(d => d.departamentCode === departamentCode);
    return dep;
  }
  
  
  getTotalOfGroupIASD(itemGroup): number {
    return itemGroup.items.reduce((sum, item) => {
      const value = item.itemName === 'expense' ? -item.total : item.total;
      return sum + value;
    }, 0);
  }

  getTotalOfGroup(parentGroup: any): number {
    let total = 0;
  
    for (const item of parentGroup.items) {
      const sign = item.itemName === 'expense' ? -1 : 1;
      total += sign * item.total;
    }
  
    return total;
  }
  


getTotalByItem(parentGroup, item) {
  return item.departments.reduce((acc: number, dep: any) => acc + Number(dep.total), 0);
}


getParentGroupMargin(parentGroup): number {

  let totalRevenue = 0;
  let totalExpense = 0;

  for (const i of parentGroup.items) {
    const total = this.getGroupTotal(i);
    if (i.itemName === 'revenue') totalRevenue += total;
    if (i.itemName === 'expense') totalExpense += total;
  }

  return totalRevenue - totalExpense;
}


getGroupTotal(group: any): number {
  return group.departments.reduce((acc, dept) => acc + (dept.total || 0), 0);
}



isCollapsed(parentGroup): boolean {
  const code = parentGroup.departamentParentCode;

  if (!(code in this.collapseStates)) {
    this.collapseStates[code] = parentGroup.items[0]?.departments?.length > 10;
  }

  return this.collapseStates[code];
}


toggleCollapse(code: string) {
  this.collapseStates[code] = !this.collapseStates[code];
}

toggleAllCollapse() {
  const newState = !this.isAllCollapsed;

  for (const group of this.groupedByParentThenItem) {
    const code = group.departamentParentCode;
    this.collapseStates[code] = newState;
  }
}





  groupByItemCode(data) {
    const map = new Map();
  
    for (const item of data) {
      const key = item.itemCode;
      if (!map.has(key)) {
        map.set(key, []);
      }
      map.get(key)?.push(item);
    }
  
    this.groupedDepartments = Array.from(map.entries()).map(([itemCode, departments]) => {
      return {
        itemCode,
        itemName: departments[0].itemName,
        itemDisplayName: departments[0].itemDisplayName, // ← por si usas esto
        departments,
      };
    });

  }


  
  getGroupTotalParam(group,item) {
    group=group?.find(d=>d.itemCode==item.itemCode);
    return group?.departments.reduce((acc, dept) => acc + (dept.total || 0), 0);
  }

  getTotalGeneral(): number {
    return this.groupedDepartments.reduce((sum, group) => {
      return sum  /*+this.getGroupTotal(group);*/
    }, 0);
  }
  


  /**Mapea los datos en formato valido para ngSelect */
  ngSelectData(data) {
    let newData = data.map((d) => {
      return {
        departmentCode: d.departamentCode,
        codeName: d.departamentCode + ' - ' + d.departamentDisplayName?.slice(0, 30),
        itemCode: d.itemCode + ' - ' + d.itemName,
        name: d.departamentDisplayName
      }
    });
    return newData
  }


  /**al momento de cerrar el ng select de busqueda busca actualiza la tabla */
  changeNgSelectAccount() {
    if (this.txtFindAccount.length === 0) {
      this.departament = this.departamentTemp;
    } else {
      this.departament = this.departamentTemp.filter(a =>
            this.txtFindAccount.includes(a.departamentCode)
        );
    }
  }
  

/**exportar excel */


headers(){
  let headers = [  
    'Tipo Ingreso', 
    'Cuenta',
    'Nombre',
    'Diezmo',
    'No Diezmo'
  ];  
  return headers;
}


styleHeaderRow(worksheet, rowNumber: number): void {
  const headerRow = worksheet.getRow(rowNumber);
  worksheet.getRow(rowNumber).height = 25;
  headerRow.eachCell(cell => {
    cell.font = { bold: true };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFBFBFBF' } // gris claro
    };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
    cell.border = {
      top: { style: 'medium' },
      bottom: { style: 'medium' },
      left: { style: 'medium' },
      right: { style: 'medium' }
    };
  });
}

styleDataRow(row,headers,index,rowspan): void {
  for (let col = 1; col <= headers.length; col++) {
    const cell = row.getCell(col);
    cell.border = {
      top: { style: index === 0 ? 'medium' : 'thin' },
      bottom: { style: index === rowspan - 1 ? 'medium' : 'thin' },
      left: { style: 'medium' },
      right: { style: 'medium' }
    };
    if (col >= 4) {
      cell.numFmt = '#,##0';
    }
  }

}


autoAdjustColumns(worksheet): void {
  worksheet.columns.forEach(column => {
    let max = 10;
    column.eachCell({ includeEmpty: true }, cell => {
      const len = cell.value ? cell.value.toString().length : 10;
      if (len > max) max = len;
    });
    column.width = max + 2;
  });
}  

styleSubtotalRows(worksheet, rowNumber: number): void {
  const subtotalRow = worksheet.getRow(rowNumber);
  subtotalRow.height = 25;
  subtotalRow.eachCell(cell => {
    cell.font = { bold: true };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFBFBFBF' } // gris claro
    };
    cell.alignment = { vertical: 'middle', horizontal: 'right' };
    cell.border = {
      top: { style: 'medium' },
      bottom: { style: 'medium' },
      left: { style: 'medium' },
      right: { style: 'medium' }
    };
    cell.numFmt = '#,##0';
  });
}


addSubtotalRow(worksheet,startCol,rowNumber,mergeCol): void {
  const lastRowNumber = worksheet.lastRow.number;
  const subtotalRow = worksheet.addRow([]);
  if (mergeCol >= 1) {
    worksheet.mergeCells(subtotalRow.number, 1, subtotalRow.number, mergeCol);
    const labelCell = worksheet.getCell(subtotalRow.number, 1);
    labelCell.value = 'SUBTOTAL';
    labelCell.alignment = { horizontal: 'center', vertical: 'middle' };
    labelCell.font = { bold: true };
  }
  for (let col = startCol; col <= worksheet.columnCount; col++) {
    const colLetter = worksheet.getColumn(col).letter;
    const cell = subtotalRow.getCell(col);
    cell.value = {
      formula: `SUM(${colLetter}${rowNumber}:${colLetter}${lastRowNumber})`,
      result: null
    };
    cell.font = { bold: true };
  }
}


addGroupedRowsToWorksheet(filterAccounts, worksheet, headers): void {
  let currentRow = 3;

  for (const group of filterAccounts) {
    const groupName = group.filterAccountName;
    const groupData = group.accounts;
    const rowspan = groupData.length;

    groupData.forEach((account, index) => {
      const rowValues = [
        index === 0 ? groupName : '',
        account.accountCode + '/' + account.subAccountCode,
        account.accountDisplayName,
        account.tithe,
        account.nonTithe
      ];

      const row = worksheet.addRow(rowValues);
      this.styleDataRow(row, headers, index, rowspan);
    });

    if (rowspan > 1) {
      worksheet.mergeCells(currentRow, 1, currentRow + rowspan - 1, 1);
    }

    const cell = worksheet.getCell(currentRow, 1);
    cell.alignment = { vertical: 'middle', horizontal: 'center' };

    currentRow += rowspan;
  }
}


createSheet(workbook: Workbook, title, headers, data) {
  const worksheet = workbook.addWorksheet(title);
  worksheet.mergeCells(1, 1, 1, headers.length);
  const titleCell = worksheet.getCell('A1');
  titleCell.value = `${title.toUpperCase()}`;
  titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
  titleCell.font = { bold: true };
  worksheet.getRow(1).height = 40;

  for (let col = 1; col <= headers.length; col++) {
    worksheet.getCell(1, col).border = {
      top: { style: 'medium' },
      left: { style: 'medium' },
      bottom: { style: 'medium' },
      right: { style: 'medium' },
    };
  }

  worksheet.getRow(2).values = headers;
  this.styleHeaderRow(worksheet, 2);
  this.addGroupedRowsToWorksheet(data, worksheet, headers); 
  this.autoAdjustColumns(worksheet);
  this.addSubtotalRow(worksheet, 4, 3, 3);
  this.styleSubtotalRows(worksheet, worksheet.lastRow.number);
}



exportToExcel(): void {
  const workbook = new Workbook();
  const data = this.departament;
  this.createSheet(workbook, 'Ingresos', this.headers(), data);
  workbook.xlsx.writeBuffer().then(buffer => {
    const blob = new Blob([buffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    this.saveExcelFile(blob, 'ingresos_' + this.getDate());
  });
}


 /**trae los datos de los departamentos de la cuenta seleccionada */
 getResumen() {
  this.budgetGenerateService.getResumen(this.filter).subscribe(res => {
    this.items = res;
    this.itemsTemp=JSON.parse(JSON.stringify(this.items));    
    this.changeFund(this.fundSelect);
    this.isLoading =false; 
    Swal.close()
  })
}

capitalize(value){
value=value??'';
return value
  .toLowerCase()
  .split(' ')
  .map(word => 
    word
      .split('-')
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join('-')
  )
  .join(' ');
}




private saveExcelFile(buffer: any, fileName: string): void {
  const data: Blob = new Blob([buffer], { type: this.EXCEL_TYPE });
  saveAs(data, `${fileName}.xlsx`);
}


/**Obtener la fecha en formato 04/12/2024 09:36:44  */
getDate() {
  let date = new Date();
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' } as const; // Opciones para la fecha
  const formattedDate = date.toLocaleDateString('es-ES', options); // Formato DD-MM-YYYY
  const formattedTime = date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit' }); // Formato HH:mm:ss
  return `${formattedDate}_${formattedTime}`;
}
getDomain(){
    const domian=window.location.hostname.split('.')
    return domian[0]+'.uch'
  }



  addHeaderPDF(doc,text,startY,entity){
    if(entity.group!='IASD'){
    autoTable(doc, {
      startY: 37,
      head: [
        [
          { content: 'Iglesia Adventista del Séptimo Día', styles: { fontStyle: 'normal', fontSize: 10 } },
        ],
        [
          { content: this.entitySelected?.name+'', styles: { fontStyle: 'italic', fontSize: 10 } },
        ]
      ],
      theme: 'plain',
      headStyles: {
        halign: 'center', 
        cellPadding: 1,   
      },
      margin: { left: 0, right: 0 },
      tableWidth: 'auto', 
      didDrawPage: function (data) {
        startY = data.cursor.y;
      },
    });
    autoTable(doc, {
      startY: startY+5,
      head: [
        [
          { content: text.title, styles: { fontStyle: 'bold', fontSize: 11 } },
        ]
      ],
      theme: 'plain',
      headStyles: {
        halign: 'center', 
        cellPadding: 0.3,   
      },
      margin: { left: 0, right: 0 },
      tableWidth: 'auto', 
      didDrawPage: function (data) {
        startY = data.cursor.y;
      },
    });
   autoTable(doc, {
      startY: startY,
      head: [
        [
          { content: text.subTitle+'', styles: { fontStyle: 'bold', fontSize: 9 } },
        ]
      ],
      theme: 'plain',
      headStyles: {
        halign: 'center', 
        cellPadding: 1,   
      },
      margin: { left: 0, right: 0 },
      tableWidth: 'auto', 
      didDrawPage: function (data) {
        startY = data.cursor.y;
      },
    });
  }else{
    startY=70;
    this.addHeaderPDFIASD(doc,text,startY,entity)
  }
    return startY;
  }


  addHtmlTable(doc, idHtml, startY, pdfWidth, lineOffsetTop = 41, columnStyles, fontStyle: 'normal' | 'bold' = 'normal') {
    autoTable(doc, {
      html: idHtml,
      startY: startY + 25,
      theme: 'plain',
      bodyStyles: { fontSize: 6, cellPadding: 2,fontStyle: fontStyle },
      headStyles: { cellPadding: 2,fontSize: 5.7 },
      footStyles: { cellPadding: 2,fontSize: 5.7 },
      styles: { fontSize: 5.7 },
      useCss: false,
      tableWidth: 'wrap',
      columnStyles: columnStyles,
      didParseCell: this.customDidParseCell,
      margin: { top: 102, bottom: doc.internal.pageSize.height -720 },
      pageBreak: 'auto',
      didDrawCell: (data) => {
        const { doc, cell, row, section } = data;

        if (section === 'head') {
          const y = cell.y + cell.height; 
          doc.setDrawColor(0, 0, 0); 
          doc.setLineWidth(0.1);
          doc.line(35, y, pdfWidth, y); 
        }
      },
      
      didDrawPage: (data) => {
        const { doc } = data;
          const headerBottomY = data.cursor.y-data.table.head[0].height; 
          doc.line(35, headerBottomY, pdfWidth, headerBottomY);
        
    
        
        startY = data.cursor.y + 1;
      },
    });
    return startY;
  }


  addTableHeaderPDF(doc, idHtml, startY, pdfWidth) {
    return this.addHtmlTable(doc, idHtml, startY, pdfWidth, 51,this.columnStyles);
  }
  
  addTablePDF(doc, idHtml, startY, pdfWidth, fontStyle: 'normal' | 'bold' = 'normal') {    
    return this.addHtmlTable(doc, idHtml, startY, pdfWidth, 35,this.columnStyles,fontStyle);
  }
  

  addFooterPDF(doc,pdfWidth){
    const totalPages = doc.getNumberOfPages(); 
    for (let pageNumber = 1; pageNumber < totalPages + 1; pageNumber++) {
      doc.setPage(pageNumber);      
      autoTable(doc, {
      startY: 742,
      body: [['Impreso:' + this.getDate(), 'Usuario:'+this.user.mail, 'Sistema:'+this.getDomain(), 'Página '+pageNumber+' de '+totalPages]],
      theme: 'plain',
      bodyStyles: { fontSize:7,cellPadding:0.3 },
      tableWidth: 'auto',
      didDrawPage:  data=> {
       doc.line(35, 737 , pdfWidth, 737 );      
      },
    });   
  }
  }


  subTitle(doc,y,entity){
    if(entity.group=='IASD'){
    doc.setFontSize(5);
    doc.setFont("helvetica", "bold");
    doc.text('Diezmo', 301, y);
    doc.text('No Diezmo',404, y);
    doc.text('Total', 526, y);
    }else{
      doc.setFontSize(5);
      doc.setFont("helvetica", "bold");
      doc.text('INGRESOS', 230, y);
      doc.text('SUELDOS(-)', 285, y);
      doc.text('OPERATIVOS(-)', 335, y);
      doc.text('REUNIONES(-)', 395, y);
      doc.text('OTORGAMIENTOS(-)', 437, y);
      doc.text('MARGEN', 537, y);
    }
  }


addHeaderPDFIASD(doc,text,startY,entity){
   if(entity.group=='IASD'){   
   autoTable(doc, {
      startY: startY,
      head: [
        [
          { content: text.title, styles: { fontStyle: 'bold', fontSize: 11 } },
        ]
      ],
      theme: 'plain',
      headStyles: {
        halign: 'center', 
        cellPadding: 0.3,   
      },
      margin: { left: 0, right: 0 },
      tableWidth: 'auto', 
      didDrawPage: function (data) {
        startY = data.cursor.y;
      },
    });
   autoTable(doc, {
      startY: startY,
      head: [
        [
          { content: text.subTitle+'', styles: { fontStyle: 'bold', fontSize: 8 } },
        ]
      ],
      theme: 'plain',
      headStyles: {
        halign: 'center', 
        cellPadding: 1,   
      },
      margin: { left: 0, right: 0 },
      tableWidth: 'auto', 
      didDrawPage: function (data) {
        startY = data.cursor.y;
      },
    });
  }
     return startY;
  }




  exportPDF() {
    const  logo = new Image();
   const doc = new jsPDF('p', 'pt', 'letter');
    let year = this.filter.year;
    const pdfWidth = (doc.internal.pageSize.getWidth())-48;
    let startY =35;   
    let title = 'Presupuesto '+year+' '+this.entitySelected?.code;
    let subTitle=' Resumen por Departamento - Version - '+this.filter.version;
 
    if(this.entitySelected?.group!='IASD'){
      startY=78; 
      for (let group of this.groupedByParentThenItem) {
        const tableId = `#table-departament-${group.departamentParentCode}`;
        startY = this.addTablePDF(doc, tableId, startY, pdfWidth);
      } 
    }else{
      startY=78;
      for (let group of this.groupedDepartments) {
        const tableId = `#table-departament-${group.itemCode}`;
        startY = this.addTablePDF(doc, tableId, startY, pdfWidth);
      }
    }
    const totalPages = doc.getNumberOfPages(); 
    for (let pageNumber = 1; pageNumber < totalPages + 1; pageNumber++) {
      doc.setPage(pageNumber);  
      if(this.entitySelected?.group=='IASD'){
        logo.src = 'assets/img/campus/'+this.entitySelected.code+'.jpg';     
        doc.addImage(logo, 'JPG', 40, 25, 130, 45,undefined, "FAST", 0.15); 
        startY=35;
      startY=this.addHeaderPDF(doc,{title:title,subTitle:subTitle},startY,this.entitySelected); 
      let y=startY+40;
      startY=startY-10
      this.subTitle(doc,y,this.entitySelected)
      } 
      else{
        startY=50;
      startY=this.addHeaderPDF(doc,{title:title,subTitle:subTitle},startY,this.entitySelected); 
      let y=startY+15;
      startY=startY-10
      this.subTitle(doc,y,this.entitySelected)
      }       
    }   
    this.addFooterPDF(doc,pdfWidth);  
    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    this.pdfSrc=this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl)
    this.open(this.preview) 
  }

}
